import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-563c6e98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Orders" }
const _hoisted_2 = { class: "Orders__list" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center py-4 flex-col border"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка заказов...", -1))
const _hoisted_5 = { class: "bg-white px-6 py-4 border flex flex-col" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "text-sm text-gray-400" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-share mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-share mr-2" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "text-center px-6 py-4 border text-sm text-gray-400 select-none"
}
const _hoisted_12 = { class: "Orders__card" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-center py-4 flex-col"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка карточки заказа...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_orders_list_item = _resolveComponent("orders-list-item")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_order_card = _resolveComponent("order-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.listLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_loader, { class: "primary mt-1" })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, "Заказов: " + _toDisplayString(_ctx.orders.length), 1),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  onClick: _ctx.emitRefresh
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Обновить ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_the_input, {
                class: "mt-2",
                placeholder: "Поиск по номеру 1C",
                value: _ctx.state.search_order_query,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.search_order_query) = $event)),
                onInput: _ctx.searchOrder
              }, null, 8, ["value", "onInput"]),
              _createVNode(_component_the_select, {
                class: "mt-2",
                placeholder: "Компания",
                loading: _ctx.data_state.companies_include.is_loading,
                failed: _ctx.data_state.companies_include.is_failed,
                options: _ctx.data_state.companies_include.list,
                value: _ctx.includeCompaniesIds,
                multiselect: "",
                "infinite-scroll": "",
                onRefresh: _cache[1] || (_cache[1] = ($event: any) => (
                            _ctx.loadCompaniesInclude(
                                _ctx.data_state.companies_include.pagination.current_page
                            )
                        )),
                onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (
                            _ctx.loadMoreCompaniesInclude(
                                _ctx.data_state.companies_include.pagination.current_page + 1
                            )
                        )),
                "search-without-refresh": "",
                onChange: _ctx.emitIncludeCompanies
              }, null, 8, ["loading", "failed", "options", "value", "onChange"]),
              _createVNode(_component_the_select, {
                class: "mt-2",
                placeholder: "Статус листа ожидания",
                loading: _ctx.data_state.wait_list_statuses.is_loading,
                failed: _ctx.data_state.wait_list_statuses.is_failed,
                options: _ctx.data_state.wait_list_statuses.list,
                value: _ctx.waitListStatusIds,
                multiselect: "",
                "search-without-refresh": "",
                onChange: _ctx.emitWaitListStatus,
                onRefresh: _ctx.loadWaitListStatuses
              }, null, 8, ["loading", "failed", "options", "value", "onChange", "onRefresh"]),
              _createVNode(_component_the_select, {
                class: "mt-2",
                placeholder: "Исключить компанию",
                loading: _ctx.data_state.companies.is_loading,
                failed: _ctx.data_state.companies.is_failed,
                options: _ctx.data_state.companies.list,
                value: _ctx.excludeCompaniesIds,
                multiselect: "",
                "infinite-scroll": "",
                onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
                onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1)
                        )),
                "search-without-refresh": "",
                onChange: _ctx.emitExcludeCompanies
              }, null, 8, ["loading", "failed", "options", "value", "onChange"]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.orders.length)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary small text mt-2",
                      onClick: _ctx.emitStartSubmitOrders
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createTextVNode(" Выдать все заказы ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.checkedOrdersIds.length)
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 1,
                      class: "primary small text mt-2",
                      onClick: _ctx.emitStartSubmitCheckedOrders
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode(" Выдать выбранные ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.orders_copy, (order, i) => {
              return (_openBlock(), _createBlock(_component_orders_list_item, {
                key: `OrderListItem-${i}`,
                item: order,
                class: _normalizeClass({ active: _ctx.selectedOrder === order.id }),
                checked: _ctx.checkIfChecked(order.id),
                onClick: _ctx.emitSelect,
                onCheck: _ctx.emitCheck
              }, null, 8, ["item", "class", "checked", "onClick", "onCheck"]))
            }), 128)),
            (!_ctx.orders.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Список пуст "))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.cardLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_loader, { class: "primary mt-1" })
          ]))
        : (_ctx.cardFailed)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 1,
              class: "border-none",
              loading: _ctx.cardLoading,
              text: "При получении карточки заказа произошла ошибка",
              "error-message": _ctx.cardErrorState.message,
              "error-url": _ctx.cardErrorState.url,
              "error-status": _ctx.cardErrorState.status,
              onRefresh: _ctx.emitRefreshCard
            }, null, 8, ["loading", "error-message", "error-url", "error-status", "onRefresh"]))
          : (_openBlock(), _createBlock(_component_order_card, {
              key: 2,
              item: _ctx.card,
              onDateChanged: _ctx.emitDateChanged,
              onStartSubmitOrder: _ctx.emitStartSubmitOrder,
              onRefresh: _ctx.emitRefreshCard
            }, null, 8, ["item", "onDateChanged", "onStartSubmitOrder", "onRefresh"]))
    ])
  ]))
}